<!-- =========================================================================================
   File Name: categoryView.vue
    Description: Category
    ----------------------------------------------------------------------------------------
    Item Name: KOZO Admin - VueJS Dashboard
    Author:  
    Author URL:   
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col w-full">
        <router-link to="/apps/projects">
          <feather-icon icon="ArrowLeftCircleIcon" svgClasses="h-8 w-8" />
        </router-link>
      </div>
      <!-- DESIGNATION FORMS -->
      <div class="vx-col w-full mb-base">
        <designation-form v-if="checkPermission(['designation','GET'])"></designation-form>
      </div>

      <div class="vx-col w-full">
        <!-- DESIGNATION LIST -->
        <vs-tabs>
          <vs-tab label="Designation List" icon-pack="feather" icon="icon-box">
            <div class="tab-text">
              <!-- DESIGNATION LIST -->
              <div>
                <designation-list v-if="checkPermission(['designation','POST'])"></designation-list>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Archive List" icon-pack="feather" icon="icon-box">
            <!-- DESIGNATION ARCHIVE LIST -->
            <div>
              <designation-list listType="archive"></designation-list>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import designationForm from "@/views/apps/designation/designationForm.vue";
import designationList from "@/views/apps/designation/designationList.vue";

export default {
  data() {
    return {
      isActive: false,
      analyticsData: [],
      isImp: false,
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      show: false,
      items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      nextNum: 10,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot"
      ]
    };
  },
  methods: {
    myFilter: function() {
      this.isActive = !this.isActive;
    }
  },
  components: {
    designationForm,
    designationList
  }
};
</script>

<style lang="scss">
#dashboard-analytics {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
